import { Inject, Injectable } from '@angular/core';

import { WINDOW } from '@modules/core/tokens/window.token';

/**
 * https://github.com/InteractionDesignFoundation/add-event-to-calendar-docs/blob/main/services/google.md
 */
export interface GoogleCalendarParams {
  text?: string;
  add?: string;
  dates?: string;
}
export const GOOGLE_CALENDAR_DATE_FORMAT = 'YYYYMMDDTHHmmSSZ';
export interface GoogleContactsParams {
  email?: string;
  familyname?: string;
  givenname?: string;
  phone?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExternalUrlService {
  private readonly pappersUrl = 'https://www.pappers.fr/entreprise';
  private readonly infogreffeUrl =
    'https://www.infogreffe.fr/recherche-entreprise-dirigeant/resultats-de-recherche?recherche=Entreprises&sirenOrSiret=';
  private readonly googleCalendarUrl = 'https://calendar.google.com/calendar';
  private readonly gafiUrl = 'https://www.fatf-gafi.org/fr/countries/liste-noire-et-liste-gris.html';
  private readonly googleSpreadsheetsUrl = 'https://docs.google.com/spreadsheets';
  private readonly googleContactsUrl = 'https://contacts.google.com';

  constructor(@Inject(WINDOW) private window: Window) {}

  openPappers(siren: string): void {
    const papersUrl = `${this.pappersUrl}/${siren}`;

    this.openUrl(papersUrl);
  }

  openInfogreffe(siren: string): void {
    const infogreffeUrl = `${this.infogreffeUrl}${siren}`;

    this.openUrl(infogreffeUrl);
  }

  openGoogleCalendar(params: GoogleCalendarParams): void {
    const queryParams = new URLSearchParams({
      action: 'TEMPLATE',
      ...params
    });

    const calendarUrl = `${this.googleCalendarUrl}/render?${queryParams.toString()}`;

    this.openUrl(calendarUrl);
  }

  openGafi(): void {
    this.openUrl(this.gafiUrl);
  }

  openDirectoryLinkWithUser(firstName: string, lastName: string): void {
    const url: string = `https://annuaire-entreprises.data.gouv.fr/rechercher?terme=${this.createUrlwithContactName(
      firstName,
      lastName
    )}`;
    this.openUrl(url);
  }

  openGoogleLinkWithUser(firstName: string, lastName: string): void {
    const url: string = `https://www.google.fr/search?q=${this.createUrlwithContactName(firstName, lastName)}`;
    this.openUrl(url);
  }

  openPappersLinkWithUser(firstName: string, lastName: string): void {
    const url: string = `https://www.pappers.fr/recherche-dirigeants?q=${this.createUrlwithContactName(
      firstName,
      lastName
    )}`;
    this.openUrl(url);
  }

  openGoogleSpreadsheets(id: string): void {
    const url = `${this.googleSpreadsheetsUrl}/d/${id}`;

    this.openUrl(url);
  }

  openGoogleContacts(params: GoogleContactsParams): void {
    const queryParams = new URLSearchParams({
      ...params
    });

    const calendarUrl = `${this.googleContactsUrl}/new?${queryParams.toString()}`;

    this.openUrl(calendarUrl);
  }

  openUrl(url: string): void {
    this.window.open(url, '_blank');
  }

  private createUrlwithContactName(firstName: string, lastName: string): string {
    return `${firstName.replace(' ', '+')}+${lastName.replace(' ', '+')}`;
  }
}
